import { useRef, useState } from "react";
import { Upload, X } from "lucide-react";
import { toast } from "sonner";
import { http } from "../../lib/api";
import { apiError } from "../../context/AuthContext";

export const UploadButton = ({ kind, onUploaded, multiple = false, label = "Upload image", testid }) => {
  const ref = useRef(null);
  const [busy, setBusy] = useState(false);
  const pick = async (e) => {
    const files = [...e.target.files];
    e.target.value = "";
    setBusy(true);
    try {
      for (const f of files) {
        const fd = new FormData();
        fd.append("file", f);
        const r = await http.post(`/admin/uploads?kind=${kind}`, fd);
        onUploaded(r.data.url);
      }
      toast.success(files.length > 1 ? `${files.length} images uploaded` : "Image uploaded");
    } catch (err) {
      toast.error(apiError(err));
    } finally {
      setBusy(false);
    }
  };
  return (
    <>
      <input ref={ref} type="file" accept="image/jpeg,image/png,image/webp,image/gif" multiple={multiple} className="hidden" onChange={pick} data-testid={`${testid}-input`} />
      <button type="button" disabled={busy} onClick={() => ref.current?.click()} className="h-10 px-4 whitespace-nowrap rounded-full border-2 border-navy text-navy text-sm font-bold flex items-center gap-2 hover:bg-navy hover:text-white transition-colors disabled:opacity-50" data-testid={testid}>
        <Upload className="w-4 h-4" /> {busy ? "Uploading..." : label}
      </button>
    </>
  );
};

export const ImageList = ({ images, onChange }) => (
  <div className="flex flex-wrap gap-2" data-testid="image-list">
    {images.map((src, i) => (
      <div key={src} className="relative w-20 h-20 rounded-xl overflow-hidden bg-sand border border-border group">
        <img src={src} alt="" className="w-full h-full object-cover" />
        {i === 0 && <span className="absolute bottom-0 inset-x-0 bg-navy/80 text-white text-[9px] font-bold text-center">MAIN</span>}
        <button type="button" onClick={() => onChange(images.filter((x) => x !== src))} className="absolute top-1 right-1 w-6 h-6 rounded-full bg-white/90 grid place-items-center opacity-0 group-hover:opacity-100 transition-opacity" aria-label="Remove image" data-testid={`remove-image-${i}`}>
          <X className="w-3.5 h-3.5" />
        </button>
        {i > 0 && (
          <button type="button" onClick={() => onChange([src, ...images.filter((x) => x !== src)])} className="absolute bottom-1 left-1 text-[9px] font-bold bg-white/90 rounded px-1 opacity-0 group-hover:opacity-100" data-testid={`make-main-image-${i}`}>
            Main
          </button>
        )}
      </div>
    ))}
  </div>
);
